import { render, staticRenderFns } from "./MbButton.vue?vue&type=template&id=053b2bd7&"
import script from "./MbButton.vue?vue&type=script&lang=js&"
export * from "./MbButton.vue?vue&type=script&lang=js&"
import style0 from "./MbButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports